document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.real-results');
  const track = document.querySelector('.real-results__track');
  if (!section || !track) return;

  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const isDesktop = () => desktopQuery.matches;

  const modal = section.querySelector('.real-results__modal');
  const modalVideo = modal ? modal.querySelector('.real-results__modal-video') : null;
  const modalClose = modal ? modal.querySelector('.real-results__modal-close') : null;
  const modalBackdrop = modal ? modal.querySelector('.real-results__modal-backdrop') : null;
  const modalMute = modal ? modal.querySelector('.real-results__modal-mute') : null;

  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  const loadVideo = (video) => {
    if (!video) return;
    if (video.src) return;
    const src = video.dataset.src;
    if (!src) return;
    video.preload = 'auto';
    video.src = src;
    video.load();
  };

  // Card videos currently on screen, kept by the IntersectionObserver below so
  // playback can resume for them when the modal closes.
  const visibleVideos = new Set();

  const resumeVisibleVideos = () => {
    visibleVideos.forEach((video) => {
      video.dataset.shouldPlay = 'true';
      video.play().catch(() => {});
    });
  };

  const pauseAllCardVideos = () => {
    track.querySelectorAll('.real-results__video').forEach((video) => {
      video.dataset.shouldPlay = 'false';
      video.pause();
    });
  };

  if (modalVideo) {
    modalVideo.addEventListener('pause', () => {
      if (modalVideo.dataset.shouldPlay === 'true') {
        modalVideo.play().catch(() => {});
      }
    });
  }

  const syncMuteButton = () => {
    if (!modalMute || !modalVideo) return;
    const isMuted = modalVideo.muted;
    modalMute.classList.toggle('is-muted', isMuted);
    modalMute.setAttribute('aria-label', isMuted ? modalMute.dataset.labelUnmute : modalMute.dataset.labelMute);
  };

  if (modalMute && modalVideo) {
    modalMute.addEventListener('click', () => {
      modalVideo.muted = !modalVideo.muted;
      syncMuteButton();
    });
  }

  const openModal = (video) => {
    if (!modal || !modalVideo || !video) return;
    loadVideo(video);
    const src = video.currentSrc || video.src || video.dataset.src;
    if (!src) return;
    if (modalVideo.getAttribute('src') !== src) {
      modalVideo.src = src;
      modalVideo.load();
    }
    modalVideo.muted = false;
    syncMuteButton();
    window.clearTimeout(hideTimer);
    pauseAllCardVideos();
    track.classList.add('is-paused');
    modal.hidden = false;
    document.body.classList.add('real-results-modal-open');
    modalVideo.dataset.shouldPlay = 'true';
    modalVideo.play().catch(() => {
      // Some browsers block unmuted autoplay; fall back to muted so the video still plays.
      modalVideo.muted = true;
      syncMuteButton();
      modalVideo.play().catch(() => {});
    });
    // Wait a paint before adding `is-open` so the ATC bar's slide-up
    // transition actually animates instead of snapping into place.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        modal.classList.add('is-open');
      });
    });
  };

  let hideTimer = null;

  const closeModal = () => {
    if (!modal || !modalVideo) return;
    // Let the ATC bar's slide-down happen before the modal is fully hidden.
    modal.classList.remove('is-open');
    document.body.classList.remove('real-results-modal-open');
    track.classList.remove('is-paused');
    modalVideo.dataset.shouldPlay = 'false';
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
    resumeVisibleVideos();
    hideTimer = window.setTimeout(() => {
      modal.hidden = true;
    }, 350);
  };

  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  const wireCard = (card) => {
    const video = card.querySelector('.real-results__video');
    if (!video || card.dataset.wired) return;
    card.dataset.wired = 'true';

    // The poster covers the card until the IntersectionObserver below loads
    // and plays it, so only cards near the viewport ever fetch or decode video.
    // Start playback once data is available instead of forcing play() on pause,
    // which fights the browser when it pauses videos under decoder/bandwidth limits.
    const resumeIfWanted = () => {
      if (video.dataset.shouldPlay === 'true' && video.paused && !video.ended) {
        video.play().catch(() => {});
      }
    };

    video.addEventListener('canplay', resumeIfWanted);
    video.addEventListener('stalled', resumeIfWanted);
    // Only on-screen cards have shouldPlay set, so resuming an unexpected
    // pause here cannot pile up decoders the way it did when every card played.
    video.addEventListener('pause', () => window.requestAnimationFrame(resumeIfWanted));

    card.addEventListener('click', () => {
      openModal(video);
    });
  };

  track.querySelectorAll('.real-results__card').forEach(wireCard);

  // Build a seamless, continuously auto-scrolling loop on desktop by
  // duplicating the slide set once and animating the wrapper with CSS.
  const setupMarquee = () => {
    if (track.querySelector('.real-results__marquee')) return;
    const slides = Array.from(track.children).filter((el) =>
      el.classList.contains('real-results__slide')
    );
    if (slides.length < 2) return;

    const marquee = document.createElement('div');
    marquee.className = 'real-results__marquee';
    track.appendChild(marquee);
    slides.forEach((slide) => marquee.appendChild(slide));

    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.clone = 'true';
      marquee.appendChild(clone);
      const clonedCard = clone.querySelector('.real-results__card');
      if (clonedCard) {
        // cloneNode copies data-wired from the original, which would make
        // wireCard skip the clone and leave it without a click handler.
        delete clonedCard.dataset.wired;
        wireCard(clonedCard);
      }
    });

    track.classList.add('is-auto-scrolling');

  };

  const teardownMarquee = () => {
    const marquee = track.querySelector('.real-results__marquee');
    if (!marquee) return;
    Array.from(marquee.children).forEach((slide) => {
      if (slide.hasAttribute('aria-hidden')) {
        slide.remove();
      } else {
        track.appendChild(slide);
      }
    });
    marquee.remove();
    track.classList.remove('is-auto-scrolling');
  };

  const syncMarquee = () => {
    if (isDesktop()) {
      setupMarquee();
    } else {
      teardownMarquee();
    }
  };

  syncMarquee();
  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', syncMarquee);
  }

  const lastTimes = new WeakMap();
  const nudgeIfStalled = (video) => {
    if (!video || video.dataset.shouldPlay !== 'true') return;
    const last = lastTimes.get(video);
    const stalled = video.paused || (last !== undefined && last === video.currentTime);
    lastTimes.set(video, video.currentTime);
    if (!stalled) return;
    // Never call load() here: it resets the download, so a slow video would
    // restart every tick and never open.
    video.play().catch(() => {});
  };

  window.setInterval(() => {
    track.querySelectorAll('.real-results__video').forEach(nudgeIfStalled);
    nudgeIfStalled(modalVideo);
  }, 1500);

  if (!('IntersectionObserver' in window)) return;

  // Only fetch a card's video once it actually scrolls into view, instead of
  // loading every video in the carousel up front.
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target.querySelector('.real-results__video');
        if (!video) return;
        if (entry.isIntersecting) {
          visibleVideos.add(video);
          loadVideo(video);
          if (!(modal && modal.classList.contains('is-open'))) {
            video.dataset.shouldPlay = 'true';
            video.play().catch(() => {});
          }
        } else {
          visibleVideos.delete(video);
          video.dataset.shouldPlay = 'false';
          video.pause();
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 100px 0px 100px' }
  );

  const observeAllCards = () => {
    track.querySelectorAll('.real-results__card').forEach((card) => observer.observe(card));
  };

  observeAllCards();

  const trackObserver = new MutationObserver(() => observeAllCards());
  trackObserver.observe(track, { childList: true, subtree: true });
});
